import { useEffect, useState } from "react";

export type ScreenOrientation = "portrait" | "landscape";

const getOri = (): ScreenOrientation => {
    const t = screen?.orientation?.type as string | undefined;
    if (t) return t.startsWith("portrait") ? "portrait" : "landscape";
    return window.innerHeight >= window.innerWidth ? "portrait" : "landscape";
};

export const useScreenOrientation = () => {
    const [ori, setOri] = useState<ScreenOrientation>(() => getOri());

    useEffect(() => {
        const update = () => setOri(getOri());

        const handleDeviceOrientation = (e: DeviceOrientationEvent) => {
            const isLandscape = Math.abs(e.gamma ?? 0) > 45;
            setOri(isLandscape ? "landscape" : "portrait");
        };

        screen?.orientation?.addEventListener?.("change", update);
        window.addEventListener("orientationchange", update);
        window.addEventListener("resize", update);
        window.addEventListener("deviceorientation", handleDeviceOrientation);

        return () => {
            screen?.orientation?.removeEventListener?.("change", update);
            window.removeEventListener("orientationchange", update);
            window.removeEventListener("resize", update);
            window.removeEventListener(
                "deviceorientation",
                handleDeviceOrientation,
            );
        };
    }, []);

    return ori;
};
